import { VARIATION_TYPES } from 'Pods/ThreeDStudio/constants'
import { VIEWER_SIDEBAR_TAB } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Whether a provider model id belongs to the retexture flow. Derived from
 * VARIATION_TYPES so the variations prefetch and the viewer's frozen-frame swap
 * can never disagree about which runs count as texture variations.
 *
 * @param {string|undefined} providerModelId - openedModel.providerModelId
 * @returns {boolean}
 */
export const isTextureModel = providerModelId => (
  VARIATION_TYPES[providerModelId]?.tab === VIEWER_SIDEBAR_TAB.TEXTURE
)
